// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"576":"m_main","599":"p_main"}[chunkId] + "." + {"576":"39541ee3","599":"26d885a6"}[chunkId] + ".chunk.css";
};